import React from 'react';
import {designSystemToken} from '@lightricks/react-design-system';

interface ShopifyIconProps {
  color?: string;
  width?: number;
  height?: number;
  className?: string;
}

function ShopifyIcon({
  color = designSystemToken('semantic.bg.neutral-inverse'),
  width = 24,
  height = 24,
  className,
}: ShopifyIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.84245 1.66111C10.4734 1.46891 11.2712 1.34336 11.7368 1.91982C11.789 1.98457 11.8746 2.18609 11.8879 2.19464L11.9144 2.20269C11.9963 2.21608 12.2123 2.19488 12.2987 2.20627C13.3767 2.34879 13.9876 3.27724 14.3371 4.23207L15.0148 4.11481L14.2108 23.5L2 21.1788C2.56436 16.7175 3.19377 12.2632 3.67699 7.79043C3.74447 7.63283 4.07529 7.51037 4.22833 7.45294C4.85249 7.21882 5.56817 7.05708 6.2128 6.87913C6.64742 4.95206 7.81235 2.2793 9.84245 1.66111ZM11.7598 9.33014C10.2595 8.83697 8.28896 9.01056 7.06101 10.0812C5.79052 11.1889 5.29133 13.5075 6.4381 14.8669C6.90566 15.4211 8.10343 16.0476 8.2167 16.77C8.38728 17.8588 7.52288 18.0257 6.68903 17.7073C6.21513 17.526 5.78115 17.1997 5.3743 16.9025L4.85831 18.8289C6.6057 20.7468 10.2059 20.8239 11.0582 17.9615C11.5181 16.4172 11.0865 15.1401 9.89193 14.1346C9.25359 13.5975 7.69208 12.901 8.40932 11.8555C8.94877 11.0699 10.519 11.4688 11.2385 11.8125L11.7598 9.33014ZM10.84 2.34234C9.27235 2.02472 7.92885 4.34661 7.47363 5.57127C7.42342 5.70647 7.13354 6.53101 7.18294 6.59983L8.76893 6.0296C9.04167 4.81278 9.51636 3.6135 10.5201 2.83648C10.682 2.71146 10.9037 2.61612 11.0379 2.50616C11.1353 2.42605 10.8914 2.35267 10.84 2.34234ZM11.6405 3.01642C10.5845 3.4823 10.0043 4.65879 9.75321 5.74404L10.2091 5.59633C10.8321 5.40521 11.8155 5.10904 11.9029 4.93032C11.9166 4.28007 11.7891 3.64427 11.6405 3.01642ZM12.3235 3.01552C12.4078 3.3714 12.522 3.73312 12.5594 4.09959C12.5734 4.23764 12.537 4.70403 12.5824 4.76918C12.6743 4.90005 13.4608 4.61181 13.6488 4.68504L13.5719 4.42543C13.371 3.80001 13.0071 3.07325 12.3235 3.01552Z"
        fill={color}
      />
      <path
        d="M15.3956 4.23745C15.5157 4.2657 16.4306 5.36953 16.6494 5.4916C17.1293 5.52092 17.609 5.58394 18.0878 5.6214C18.2172 5.63155 18.5869 5.58742 18.6603 5.67332L21 22.1152L14.4926 23.5L15.3019 4.30548C15.3176 4.26557 15.349 4.22686 15.3956 4.23745Z"
        fill={color}
      />
    </svg>
  );
}

export default ShopifyIcon;
